import { LoaderIcon } from '@p2p/assets/svg';
import { Typography } from '@p2p/components/Typography';
import { usePaymentTemplate } from '@p2p/entities/templates';
import { useGetMerchantOrderQuery } from '@p2p/services';
import { addZero } from '@p2p/shared/functions';
import classNames from 'classnames';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { MainContainer } from '../MainContainer';
import { TransferHead } from '../TransferHead';
import styles from './TransferSearch.module.scss';

export const TransferSearch = () => {
  const { setActiveIndex } = usePaymentTemplate();
  const { id = '' } = useParams<{ id: string }>();
  const { isLoading, data: order } = useGetMerchantOrderQuery(id, { skip: !id });

  const timer = `${addZero(Math.floor((order?.time_left ?? 0) / 60))}:${addZero(
    (order?.time_left ?? 0) % 60,
  )}`;

  useEffect(() => {
    setActiveIndex(2);
  }, [setActiveIndex]);

  if (!order || isLoading) {
    return null;
  }

  return (
    <MainContainer className={styles.mainContainer}>
      <div className={styles.transferHeadContainer}>
        <TransferHead order={order} />
      </div>
      <div className={styles.transfer_dialog__body}>
        <div className={classNames(styles.transfer_dialog__icon_wr, styles.loader)}>
          <LoaderIcon className={styles.transfer_dialog__icon} />
        </div>

        <div className={styles.transfer_dialog__content}>
          <Typography variant="h1" color="heading">
            Поиск платежа
          </Typography>
          <Typography variant="h2" color="heading">
            {timer}
          </Typography>
        </div>

        <div className={styles.transfer_dialog__description}>
          Пожалуйста, не закрывайте страницу
          <br />
          до завершения обработки.
        </div>
      </div>
    </MainContainer>
  );
};
